import React, { useState } from 'react';
import clsx from 'clsx';

interface TooltipProps {
  content: string;
  children: React.ReactNode;
  position?: 'top' | 'bottom';
}

/** Hover/focus tooltip wrapper. `position` decides whether the bubble appears above or below the trigger. */
export const Tooltip: React.FC<TooltipProps> = ({ content, children, position = 'top' }) => {
  const [isVisible, setIsVisible] = useState(false);

  return (
    <div
      className='relative flex items-center justify-center'
      onMouseEnter={() => setIsVisible(true)}
      onMouseLeave={() => setIsVisible(false)}
    >
      {children}

      {isVisible && (
        <div
          className={clsx(
            'absolute z-50 flex items-center justify-center',
            'pointer-events-none whitespace-nowrap',
            // Dimensions & Shape
            'h-[21px] min-w-[38px] rounded-5 px-2',
            'bg-black',
            // Typography
            'font-sans text-10 font-semibold leading-160 tracking-[-0.02em] text-white',
            // Positioning
            position === 'top' ? 'bottom-full mb-1' : 'top-full mt-1'
          )}
        >
          {content}
        </div>
      )}
    </div>
  );
};
